// @ts-nocheck
import { uploadTransformationUrl } from '@dmi-mch/utils'
import { cloudinary } from '@constants'

import { useEffect } from 'react'

/**
 * This hook takes the image out of the pageData, and makes a preload. Usually used to preload next < > image
 * @param pageData
 */
function useNextArtworkImagePreview(pageData: ABTypes.Monolith.ArtworkDetail) {
  /** All data **/
  const artworkInfo = { ...pageData }
  const images = artworkInfo.images
  const croppedHeaderImages = artworkInfo.croppedHeaderImages
  const isDesktopView = typeof window !== 'undefined' && window.innerWidth > 1023
  const headerImageDesktop = isDesktopView ?
    croppedHeaderImages && croppedHeaderImages[0] : croppedHeaderImages && croppedHeaderImages[2]
  const headerImage = croppedHeaderImages && croppedHeaderImages.length > 0 ? headerImageDesktop : images && images[0]
  let imageSrc = ''
  const reducedHeight = headerImage?.height && Math.round(headerImage.height / 2)
  const reducedWidth = headerImage?.width && Math.round(headerImage.width / 2)
  const cl_params = `w_${reducedWidth},h_${reducedHeight},c_fill,q_auto,dpr_1.0,f_auto`
  if (croppedHeaderImages && croppedHeaderImages.length > 0) {
    const cloudfrontURL = `https://${getEnvConfig.fe.cdn.cloudfrontKey}.cloudfront.net${getEnvConfig.fe.cdn.cloudinaryMappingPath}${getEnvConfig.fe.cloudinary.name}/image/fetch/`
    // @ts-ignore
    const transformations = `c_fill,q_auto,dpr_1.0,f_auto,w_${parseInt(headerImage?.metadata.cropWidth / 2.5)},h_${parseInt(headerImage?.metadata.cropHeight / 2.5)}/`
    const originalImage = headerImage?.url
    imageSrc = `${cloudfrontURL}${transformations}${originalImage}`
  } else {
    imageSrc = uploadTransformationUrl(headerImage?.url ?? '', cl_params, {
      transformUrl: cloudinary.throughCloudfront
    })
  }

  useEffect(() => {
    const img = new Image()
    img.src = imageSrc
    img.onload = () => {}
  }, [imageSrc])
}

export default useNextArtworkImagePreview
